import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin JWT (if present) to every request automatically.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("startinc_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function createConsultation(payload) {
  const { data } = await api.post("/consultations", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

// ---------- Admin auth ----------
export async function adminLogin(email, password) {
  const { data } = await api.post("/admin/login", { email, password });
  localStorage.setItem("startinc_admin_token", data.token);
  localStorage.setItem("startinc_admin_email", data.email);
  return data;
}

export function adminLogout() {
  localStorage.removeItem("startinc_admin_token");
  localStorage.removeItem("startinc_admin_email");
}

export function getAdminEmail() {
  return localStorage.getItem("startinc_admin_email");
}

export async function adminMe() {
  const { data } = await api.get("/admin/me");
  return data;
}

// ---------- Blog posts (admin) ----------
export async function adminListPosts() {
  const { data } = await api.get("/admin/posts");
  return data;
}

export async function adminGetPost(id) {
  const { data } = await api.get(`/admin/posts/${id}`);
  return data;
}

export async function adminCreatePost(payload) {
  const { data } = await api.post("/admin/posts", payload);
  return data;
}

export async function adminUpdatePost(id, payload) {
  const { data } = await api.put(`/admin/posts/${id}`, payload);
  return data;
}

export async function adminDeletePost(id) {
  await api.delete(`/admin/posts/${id}`);
}

// ---------- Blog posts (public) ----------
export async function listPosts({ category } = {}) {
  const params = {};
  if (category && category !== "all") params.category = category;
  const { data } = await api.get("/posts", { params });
  return data;
}

export async function getPostBySlug(slug) {
  const { data } = await api.get(`/posts/${slug}`);
  return data;
}
